export default {
  login: {
    code: "驗證碼",
    phone_code: "手機驗證碼",
    code_pla: "請輸入驗證碼",
    get_code: "獲取驗證碼",
    send_code: "秒後可重新獲取",
    password_pla: "請輸入密碼",
    forget_password: "忘記密碼",
    password: "密碼",
    mobile_pla: "請輸入手機號",
    mobile_pla_bind: "請輸入要關聯的手機號",
    mobile: "手機號",
    bind_mobile: "關聯手機號",
    bind_mobile_tip: "請關聯手機號碼再繼續",
    tips_text: "使用手機獲取驗證碼即可自動註冊或登入",
  },
  toast: {
    switchLangSuccess: "切换中文成功",
  },
  route: {},
  common: {
    rate: "今日匯率",
    huilv: '匯率',
    please_enter: "請輸入",
    please_choose: "請選擇",
    "add": "新增",
    "delete": "刪除",
    "delete_modal": "是否確認刪除？",
    "edit": "編輯",
    bind: "關聯",
    unbind: "取消關聯",
    "submit_btn": "確認",
    submit_btn2: "確定",
    "cancel_btn": "取消",
    empty: "暫無資料",
    help_title: '您好，有什麼可以幫助到您？',
    help_des: '請輸入關鍵字，如：運費、手續費、物流等',
    choose: "必選",
    submit_success: "提交成功",
    submit_fail: "提交失敗",
    mfree: "免費",
    xsj: "項數據",
    zwsj: "暫無數據",
    zhang: "張",
    mai: "賣",
    copy: "複製",
    jia: "價",
    xiang: "項",
    dian: '點',
    xtb: "新台幣",
    rmb: "人民幣",
    zhanshi: "展開",
    active_tab_footer_1: "顯示全部平台",
    active_tab_footer_2: "僅顯示當前平台",
    notice_read_1: "全部標示已讀",
  },
  navBar: {
    userName: "用戶名",
    please_login: "請登入",
    my_package: "我的包裹",
    user_center: "用戶中心",
    help_center: "幫助中心",
    auctions: "競拍中心",
    app_download: "APP下載",
  },
  home: {
    title: "人氣網站",
    category: "日淘曬單",
    category2: "日淘攻略",
  },
  personal_nav_list: {
    order: "我的訂單",
    package_details: "包裹詳情",
    auction_order: "拍賣訂單",
    service_work_order: "服務工單",
    personal_information: "個人資料",
    fund_management: "資金管理",
    address_management: "地址管理",
    account_settings: "帳號設定",
    identity_authentication: "EZWAY易立委",
    auction_credit_rating: "競拍信用等級",
    user_level: "會員等級",
    my_collection: "我的收藏",
    zyaddress: "集運地址",
    coupon: "優惠劵",
    points: "點數",
    cyjf: "持有點數",
    balance: "餘額",
    coupons: "優惠券",
  },
  "user_level": {
    "cgz": "成長值達到",
    ksj: "可升級",
    "wdc": "未達成",
    ydcdj: "已達到此等級",
    ydc: "已達成",
    "sjtq": "升級獲得更多特權",
    "cqhyk": "出示會員卡",
    "hxy": "還需要",
    "chengzz": "成長值",
    djfl: "等級福利特權",
    m: "運費 M 幣回饋",
    photo_text: "免費入庫前拍照",
    yhj: "專屬優惠券",
    kf: "專屬客服",
    date_dialog: "當前等級將到期，屆時將根據您的成長值重新評估會員等級"

  },
  "calculate": {
    "btx": "請輸入必填選項",
    "title": "費用計算機",
    "fyys": "費用預算",
    "title_tip": "您可以使用此計算機，預算代標／代購時所需要的費用總和。",
    "btxm": "為必填項目",
    "jsgj": "寄送國家・地區",
    "goods_price": "商品價格／中標價格",
    "zlcc": "重量 / 尺寸",
    "lenght": "長度",
    "width": "寬度",
    "height": "高度",
    "cn_fee": "代購手續費",
    zzsxf: "轉帳手續費",
    "fee": "國內運送費",
    "agency_fee": "出口代理費（代日本郵政收取）",
    "yg": "預估",
    "zysx": "注意事項",
    "tips1": "報價內容僅供參考，根據實際情況最終金額可能出現變動。",
    "tips2": "報價收取的費用不包括進口國關稅。",
    "tips3": "除郵政線路，當「體積重量」大於「實際重量」時，計費重量按照體積重量計算。",
    "js": "計算",
    "ysjg": "費用預算結果",
    "fk": "付款",
    "gjyf": "國際運費",
    "fsfs": "可選擇的發送方式",
    "xskf": "線上客服",
    "scwz": "收藏網站",
    "top_back": "返回頂部",
    ygsx: "預估時效",
    yjsm: "【說明】"
  },
  other: {
    history: "搜索歷史",
    jp_search:"日文詞搜尋",
    zh_search:"中文詞搜尋",
    history_modal: '您確定要刪除搜索歷史嗎？',
    history_modal_all: '您確定要清空搜索歷史嗎？',
    keyword_modal_all: '您确定要删除這个關鍵詞嗎？',
    rmtj: "熱門推薦",
    keyword_place: '請輸入商品名稱、商品ID、官網連結…',
    goods_name: "商品名稱",
    goods_num: '商品數量',
    pack_weight: "包裹重量",
    update_time: '更新時間',
    goods_name_place: "請輸入商品名稱",
    more_xscc: "更多線上商城",
    my_zj: "我的足跡",
    keyword_text: "關鍵詞",
    dp: "代購/代拍",
    dp_1: "請輸入商品或拍賣網址，即可跳轉至下一個操作頁面。",
    checkbox: "全選",
    checkbox_1: "已選擇",
    serviceRadio: "已閱讀並同意",
    serviceRadio2: "《錢包服務協定》",
    serviceRadio3: "請仔細閱讀並勾選服務協定",
    order_id: "訂單ID",
    请使用微信扫描二维码绑定: "打開微信並掃描此行動條碼",
    请使用微信扫描二维码登入: "打開微信並掃描此行動條碼",
    tofh: "去發貨",
    wait_package: "待捆包",
    kqwxtzcg: "開啟微信通知成功",
    qxwxtzcg: "關閉微信通知成功",
    wait_pay_ship_fee: '待付國際運費',
    wait_send_package: '待發出',
    sqgd: "申請工單",
    checkOff: '清點核對',
    binning: '分箱服務',
    returnForward: '退貨轉寄',
    photos: '拍照服務',
    nullification: '廢棄申請',
    submit_fahuo: '提交發貨',
    gd_details: "工單詳情",
    cart: '購物車',
    jst: '結算台',
    zbgm: "暫不購買",
    ydty: "已閱讀和同意",
    zyts: "重要提示",
    order_tip1: "您好！請您在購買前務必仔細閱讀並完全理解本提示的所有內容，並依據自身的風險承受能力作出判斷後再下單購買。具體提示如下",
    order_tip2: "- 關於退換貨、取消訂單",
    order_tip3: "當您於「買到手」平台完成下單並付款後，「買到手」將依您所選商品，立即於境外完成相應之採購作業，並支付相關採購費用。由於境外交易環境與台灣不同，境外商品不適用「七日鑑賞期」相關規定，因此我們不提供無理由退貨服務，敬請見諒。訂單完成付款後，如非因買到手之原因，原則上恕無法取消訂單。",
    order_tip4: "- 關於發票",
    order_tip5: "您在「買到手」平台選擇代購的商品，商品費用均是支付給「買到手」的國外合作夥伴。「買到手」在台灣的經營主體並非銷售主體，因此無法向您提供商品發票。國外的合作夥伴僅能根據當地法律向您開具相應憑證。若您需要國外合作夥伴開具憑證，請聯繫客服處理。",
    order_tip6: "- 關於退款",
    order_tip7: "若因賣家無法出貨、商品缺貨、商品下架等非用戶因素，導致訂單無法完成時，您已支付之款項將退回至您的買到手帳戶餘額中。帳戶餘額可繼續用於支付平台內任何資費。如申請將餘額提領至原付款帳戶，將依提領金額酌收 2% 的提領手續費。",
    order_tip8: "- 關於檢品服務",
    order_tip9: "「買到手」為您代為採購商品後，您可以選擇直接辦理貨運服務，這種情況下我們不會打開賣家寄出的包裹；如果您有顧慮，也可以選擇「買到手」的檢品服務。我們的工作人員會為您打開包裹進行外觀檢查（人工檢查），但檢品服務需要您額外支付費用，具體費用標準請參考服務說明。",
    order_tip10: "- 關於商品",
    order_tip11: "如果發生商品與描述不符、錯發漏發或假貨等問題，應由商品的國外賣家承擔相應責任。「買到手」無法承擔因非「買到手」自身原因導致的退換貨或賠償責任，敬請諒解。商品若為二手商品，請注意其與新品之間存在差異。您選擇的商品來自境外，境外有關質量、安全、衛生、環保、標識等標準可能與我國標準存在差異，請您理解。",
    goods_details_txt: "商品詳情",
    shipment_step1: '發貨清單',
    shipment_step2: '申報信息',
    shipment_step4: '增值服務',
    consignee_title: "收貨人信息",
    ezway: "EZ WAY 易利委",
    ezwayadd: "添加 EZ WAY 易利委",
    address: "新增收貨地址",
    choose_pack: "選擇的包裹",
    order_num: "訂單號",
    wait_shenbao: "代填申報信息",
    zx_wait_shenbao: "自行填報申報信息",
    weituo_des: "委託日本倉庫填寫出口報關稅，費用為訂單內的包裹總數*150日元",
    weituo_des2: "委託日本倉庫填寫出口報關單，避免因申報信息缺失導致包裹被退回",
    weituo_des3: '根據海關要求，建議您如實填寫商品信息（內件品名、數量、價格）',
    custom_name: '名稱',
    custom_price: '單價',
    service_text: '運費為預估價格，依據最終打包完成後的重量確定實際運費。',
    "service_desc": "請填寫方式，如未填寫預設加固全部商品",
    "xqbc": "需求補充",
    "ts_text": "特殊要求請填寫在這，工作人員會在合理的範圍內對用您的要求",
    "tsbz": "特殊備註",
      "service_process": "服務流程",
      "wait_dbwc": "等待打包完成",
      "wait_notice": "將會推送通知打包完成",
      "pay_gjyf": "支付國際運費",
      "fh_wc": "發貨完成",

      "wxts": "溫馨提示",
      "qxdd": "確定要取消訂單嗎？",
      "qxyycj": "確定要取消預約出價嗎？",
      read_msg: "您確定要全部標記成已讀嗎？",
      "gmykj_des": "購買一口價商品需要帳號餘額充足",
      "fzcghwf": "支付後無法取消訂單，請謹慎考慮後再進行支付",
      qxbd: "確定要取消關聯嗎？",
    close: "關閉",
    open: "開啟",
          kqwxtz: "確定要開啟微信通知嗎？",
    qxwxtz: "確定要關閉微信通知嗎？",
      qrsdhw: "請確認您已收到貨物。",
      "current_price": "當前金額",
      "min_jj": "最低加價金額",
      "qr_zdjj": "請確認是否以最低金額",
      "jxjb": "繼續競標",
      "zy": "注意：我們支援取消發貨，取消發貨後，包裹將返回至待發貨狀態，您可以重新選擇打包並且發貨，此時如果該包裹已經打包，產生合箱費用的，需要支付合箱費用後才可以繼續發貨。確定要取消發貨嗎？",
      "gy_ysfs": "更改運輸方式",
      "gjwlf": "國際物流費",
      "sxf": "手續費",
      "hj": "合計",
      "qxfh": "取消發貨",
      "del_sell": "刪除已售",
      "del_all": "清空全部",
      del_check: "删除選中",
      "yf_ss": "運費試算",
      "qjz": "去結賬",
      "gzd": "個賬單",
       country_place:"選擇收貨地區",
       "select_service": "可選服務",
        "photo_des": "請注意：若您選擇的拍照服務類型與您實際的拍照需求不符，倉庫將不予進行服務操作，直接退回您的拍照服務費用",
        "photo_des2": "對於可選服務的任何要求，您可直接填寫在商品備註中",
      "back_card": "返回修改購物車",
      "wallet": "可用餘額",
    "fwfy": "服務費用",
    "see_inbound_photo": "查看入庫照片",
    "see_all_yhj": "查看所有優惠券",
    wzlj: "網站連結",
    jzq: "在截止拍賣前5分鐘時出價的金額",
    "jp1": "本次競拍至少加價",
    "jp2": "預約下標會在拍賣結束大約5分鐘前由系統自動下標。",
    "jp3": "您輸入的最高下標價格在拍賣結束前已被其他買家超過，則預約下標失敗",
    "jp4": "拍賣賣家提前取消了拍賣，則預約下標失敗",
    "jp5": "當您申請預約下標後，將無法對同一個拍賣再進行通常的下標。請取消預約下標後再進行通常的下標。",
    "jp6": "拍賣結標前15分鐘起即不受理取消以及下標",
    ljxb: "立即下標",
    yyxb: '預約下標',
    "sy_time": "剩餘時間",
    "ykjgm": "一口價購買",
    "dd_totale": "訂單總額",
    gw_link: "官網直鏈",
    xbls: "下標歷史",
    "copy_share": "複製成功去分享吧",
    "copy_success": "複製成功",
    "copy_fail": "複製失敗",
    xjia: "現價",
    "yjfw": "議價服務",
    "yjje": "請輸入議價後購買的金額",
    "yjbcg": "如果議價不成功則以原價購買",
    "hxyy": "還是想擁有它",
    "yjdes": "請注意：進行議價則無法自動下單購買，需要人工確認後才能購買。當客服非處於在線狀態時，將無法為您處理議價事宜，這可能會導致商品在未得到您的最終確認前就被其他人購得。",
    "close_btn": "關閉",
    "qxyj": "取消議價",
    "qing": "請",
    "smzf": "掃碼支付",
    "zfwt": "支付遇到問題？聯繫客服",
    "zfwc": "已完成支付",
    qrxykzf: "請您在新窗口中使用信用卡進行支付。",
    yj: "議價",
    cpjg: "產品價格",
    yebz: "您當前的餘額不足",

    tjgd: "提交工單",
    jlms: "請您儘量描述您的需求，我們會儘量按照您的需求來執行",
    fqhwfzh: "废弃后无法追回，请确认是否继续？",
    jplb: "競拍類別",
    "checkoff1": "填寫包裹詳情提交後，可代為核對清點實際到貨商品及數量是否一致",
"checkoff2": "1~10件 200日元，11~20件 300日元，21~30件 400日元，31~40件 500日元，以此類推",
"checkoff3": "若為填寫包裹詳情收費x2計算",
"checkoff4": "提交核對申請後無法取消，請您理解與知悉！",
"checkoff5": "我確定包裹內容，希望核對數量",
"add_wait_qd": "新增待清點商品",
"jcssrsz": "僅支持輸入數字",
"bqdbrnr": "我不確定包裹內容，希望核對數量",
"bgtz": "買到手將為您清點全部包裹並進行告知，請提交後關注【APP站內信通知】",
"binning1": "將包裹內指定的物品取出組成新的包裹。",
"binning2": "分箱完成後，將會有新的包裹入庫，同時會發送分箱完成的通知至您的App，請注意查收。",
"binning3": "若未填寫包裹詳情的我們會將一個包裹平均分成多個包裹。",
"binning4": "1~10件300日元；11~20件500日元；21~30件700日元；31~40件900日元，依此類推。",
"binning5": "提交分箱申請後無法取消，請您理解與知悉",
"binning6": "我希望準確按照要求分箱",
"add_binning": "新增分箱明細",
"fz": "分組",
"pjfx": "我希望粗略平均的分箱",
"xypjfx": "想要平均分成箱數",
"fxsl": "分箱數量",
    del_goods_notice: "確定要删除商品嗎?",
    pmtip: '在截至拍賣前5分鐘時出價的金額',
    tag2: '幾乎未使用',
    tag3: '沒有明顯劃痕和污垢',
    tag4: '有一些劃痕或污垢',
    tag5: '有明顯劃痕或污垢',
    tag6: '總體狀態較差',
    customizationValue:"以下信息如与代購無關內容，或您不知道如何選擇可不填寫選項，買手會根據實際情況選擇填寫",
    service_tip1: "本站服務條款",
    service_tip2: "訂購前須知",
  },
  "return_forward": {
    "notice": "包裹進行退貨或轉寄其他日本境內地址時，每一個包裹收取500日元手續費，運費實收（不支持合箱）",
    "notice2": "此包裹轉寄至",
    "name": "收貨人",
    "name_place": "收貨人姓名",
    "mobile": "電話號碼",
    "mobile_place": "收貨人電話號碼",
    "country": "所在地區",
    "address": "轉寄地址",
    "zipcode": "郵政編碼",
    "zipcode_place": "所在地的郵編",
    "desc_place": "備註資訊"
  },
  "photo_service": {
    "notice": "提供客戶指定的拍照內容，或掃描包裹內文件，收取500日元",
    "notice2": "您可以在下方簡單描述您拍照的需求",
    "xzxq": "拍照需求",
    "xzxq_place": "請您儘量描述您的需求，我們會儘量按照您的需求來完成拍照"
  },
  "nullification": {
    "notice": "根據實際包裹商品內容、重量、體積計算費用",
    "notice2": "您可以將其他補充需求填寫到下方輸入框"
  },
  address_info: {
      name: "收貨人",
      mobile: "手機號碼",
      invite_num: "推薦人代號",
       invite_title: '邀請您註冊買到手',
      invite_title2: '日本優品輕鬆買到手',
      btn_text: "登記並下載APP",
      djcg: "登記成功！",
      xzdj: "請下載APP使用填寫的手機號碼登入",
      country_name: "所在地區",
      address: "詳細地址",
      zipcode: "郵政編碼",
      checked: "設為默認",
      tip: "提醒：下次發貨會優先使用此地址"
  },
  account_info: {
    sfwtg: "您的身份信息審核未通過，請重新重新上傳",
    zsh: "正在審核您的身份信息…",
    ysc: "已上傳您的身份信息",
    edit: "修改資訊",
    realname: "真實姓名",
    cardnum: "證件號碼",
    scsfz: "上傳您的身份證照片",
    scsfz_1: "確保照片畫面清晰，且身份證件正面的照片能清楚顯示您的面部",
    gjmds: "我們根據買到手的",
    ys: "隱私政策",
    cl: "處理您的身份信息，不會將這些信息透露給您的賣家/買家或者其他商家。",
    submit: "提交確認信息",

    user_id: "會員ID",
    nickname: "暱稱",
    mobile: "聯繫方式",
    email: "關聯郵箱",
    line: "關聯 LINE 登入",
    password: "密碼管理",
    edit_pass: "修改密碼"
  },
  popular_questions: {
    title1: "買到手提供什麼服務？",
    p1: "全方位瞭解買到手可提供的服務方案",
    detail_txt: "查看詳情",
    title2: "使用流程",
    p2: "簡單2步將日本商品交付您手中",
    title3: "為何選擇買到手？",
    p3: "全方位保障 商品輕鬆寄至全球各地",
    title4: "費用構成（免代購手續費）",
    p4: "透明收費 實时匯率 低價優質",
  },
  collection_info: {
    goods: "商品",
    seller: "店鋪",
    category: "分類",
    keywords:"關鍵詞",
    black_seller:"賣家黑名單",
    "scmj": "收藏賣家",
    "sccg": "收藏成功",
    "qxsc": "取消收藏",
    "lhmj": "拉黑賣家",
    "jclh": "解除拉黑",
    "lh": "拉黑",
    "jc": "解除"
  },
  auction_info: {
    zl: "種類",
    kts: "可同時進行競拍的數量",
    jped: "合計競拍額度",
    qrkt: "確認開通",
    wxts: "溫馨提示",
    tips: "確定要取消當前競拍信用等級嗎？沒有信用等級您將失去參與代拍的資格！！如確認取消，將凍結的",
    tips2: "退還至錢包。",
    "yjbzj": "已繳保證金",
    "qxbzj": "取消保證金",
    "wkt": "未開通",
    "current_level": "當前等級",
    "level": "級",
    tip_cancel: '暫不開通',
    tip1: "- 關於競拍保證金解除",
    tip2: "當您競拍得標（競拍獲勝）後，",
    tip2_1: "請於 48 小時內完成付款，",
    tip2_2: "以利訂單順利成立。",
    tip3: "若超過 48 小時仍未完成付款，系統將視同自動棄標。棄標後將扣除競拍保證金，並另行收取商品成交金額 30% 的棄標手續費。",
    tip4: "為避免產生相關費用，並維護您的競拍信用，建議您於結標後儘速完成付款。",
    tip5: "- 關於競拍保證金解除",
    tip7:"當競拍保證金解除後，相關金額將返還並存入您的帳戶餘額中。",
    tip8: "帳戶餘額可用於支付平台內各項費用，包括商品款項、運費、服務費用等。",
    tip9: "如需將帳戶餘額提領至您的個人帳戶，",
    tip10:"平台將依提領金額收取 2% 的提領手續費。",
    tip11: "請您於申請提領前詳閱並確認相關費用說明。",
    tip12: "我已詳閱並理解以上說明，並同意依規定辦理"

  },
  mercari: {
    title: "日本煤爐",
    intro_desc: "日本最大的閒置交易平臺",
  },
  yahoo_intro: {
    title: "雅虎拍賣",
    intro_desc: "日本最大的網絡拍賣平臺",
  },
  rakuten: {
    title: "樂天商城",
    intro_desc: "日本最大的綜合電商平臺",
  },
  category_list: {
    home_text: "首頁",
    all_text: "所有分類",
    clear_text: "清除指定條件",
    popular_categories: "熱門分類",
    recommending_commodities: "推薦商品",
    low_price: "最低價格",
    max_price: "最高價格",
    goods_price_text: "商品價格",
    goods_remark: "購買備注",
    glgzj: "關聯關鍵字",
    glgzh: "關鍵詞組合",
  },
selfService: {
    title: "代購站點",
    dialog_tips: "您正在嘗試訪問以上鏈接，將前往外部瀏覽器打開。",
    intro_desc: "通過以下步驟進行代購",
    step1: "1. 找到希望購買的商品頁面",
    step2: "2. 複製商品鏈接",
    step3: "3. 將購買連結複製到表單",
    submit_btn: "跳轉到網站",
    tips: "關閉後將無法保存已填寫的信息，確定關閉嗎？",
    cancel_btn: "繼續填寫",
    close_btn: "確定關閉",
    add_href: "添加代購訂單",
    add_title: "提交代購訂單",
    url: "購買鏈接",
    goodsTitle: "商品標題",
    variant_name: "商品規格",
    variant_name_pla: "商品型號/顏色/尺寸 購買不同規格請多次提及代購訂單！",
    price: "商品價格",
    num: "代購數量",
    note: "購買備注",
    thumb: "上傳圖片",
    notice: "代購須知",
    fwsm: "服務說明",
    ljgm: "立即購買",
    gwc: "加入購物車",
    notice1: "1. 由於海外代購的特殊性，商品下單支付後，無法單方面取消或者退換貨。請下單前仔細閱讀商品的詳情描述再購買。",
    notice2: "2. 買到手僅提供交易平台和代購服務，無法保證賣家所售商品的真偽和質量，無法承擔商品本身瑕疵或質量問題的賠償責任。",
    notice3: "3. 商品價格為運費包含稅費等購買時產生的費用的含稅價格總和，如若商品運送到臺灣需要支付額外費用的情況，在商品抵達買到手倉庫時會向您請求產生的費用。",
     "url_text": "輸入商品鏈接，並點擊按鈕前往下一步",
    "url_btn": "跳轉訂購頁面"
  },
  "notice_info": {
    "notice_title": "消息中心",
    "no_new_notice": "還沒有新的消息",
    "gonggao": "公告消息",
    "dingdan": "訂單消息",
    "paimai": "拍賣通知",
    "zhannei": "站內消息"
  },
  footer: {
    service_related: "服務相關",
    use_instruction: "使用說明",
    help_center: "幫助中心",
    customer_service: "客服服務",
    privacy_protection: "隱私保護",
    user_agreement: "用戶協議",
    payment_and_delivery_title: "支付與配送",
    cost_explanation: "費用說明",
    payment_method: "支付方式",
    delivery_explanation: "國際物流",
    prohibited_items: "禁運物品",
    about_tariff: "關於關稅",
    about_us_title: "關於我們",
    company_profile: "公司簡介",
    red_book: "小紅書",
    douyin: "抖音",
    weibo: "微博",
    enterprise_customers: "企業客戶",
    beware_of_fraud: "謹防詐騙",
    contact_us_title: "聯繫我們",
    customer_service_hours: "客服工作時間",
  },
  order_status: {
    pending_processing: "待處理",
    "pending_processing2": "未處理",
"processing": "處理中",
"processing_pass": "已處理",
"fail_processing": "處理失敗",
    pending_payment: "待付款",
    pending_stock_in: "待入庫",
    pending_shipment: "待發貨",
    pending_receipt: "待收貨",
    completed: "已完成",
    cancelled: "已取消",
    order_name: "商品資訊",
    order_current_price: "當前價格",
    work_order_type: "工單類型",
    my_order_amount: "我的出價",
    order_nums: "重量",
    order_amount: "金額",
    order_status: "狀態",
    order_operate: "操作",
    order_remark: "訂單備註",
    jxjj: "繼續出價",
    remark: "備註",
    purchasing_fee: "代購手續費",
    "fee_detail": "收費明細",
    "current_exchange_rate": "當前匯率",
    "total_goods_price": "商品總價",
    "domestic_shipping_fee_in_japan": "日本國內運費",
    "shipping_fee": "日本國內免運費",
    "additional_service": "附加服務",
    "coupon": "優惠券",
    "ygq": "已過期",
    "points_deduction": "點數抵扣",
    "total_price": "總價格",
    order_details_btn: "訂單詳情",
    order_goods_title: "訂單商品",
    "end_time": "截止時間",
    "shelves_time": "發貨時間",
    "ship_method_name": "運輸方式",
    "ship_fee": "運輸費用",
    "quantity": "數量",
    "mfee": "免運費",
    "authenticity": "支援真偽鑑定",
    "ys": "已售"
  },
  bread: {
    personal_center: "個人中心",
    my_service_orders: "我的工單",
    inventory_check: "清點核對",
  },
  action: {
    all: "全部",
    leading: "領先中",
    booking: "預約中",
    won_bid: "已得標",
    wait_pay: "待支付",
    outbid: "被超越",
    ended: "已結束",
  },
  fundmanagement: {
    fund_record: "資金紀錄",
    withdrawal_record: "提領記錄",
    points_record: "點數記錄",
    account_balance: "帳號餘額",
    withdrawal: "提領",
    withdrawal_tip: "提領收取提領金額 2% 的手續費",
    chongzhi: "充値",
    money:"充値金額",
    money_tip: "請輸入充値金額",
    account_name: "請輸入要提領的賬戶(銀行賬戶)",
    account_num:"請輸入提領金額",
    payment_time: "付款時間",
    withdraw_time: "提領時間",
    payment_account: "付款賬號",
    amount_yuan: "金額（元）",
  },
  bargain: {
    '时间': '時間',
    '备注': '備注',
    '日元': '日元',
    '议价详情': '議價詳情',
    '议价中': '議價中',
    '议价成功': '議價成功',
    '议价失败': '議價失敗',
    '待您确认': '待您確認',
    '去确认': '去確認',
    '议价至': '議價至',
    '日元, 议价状态': '日元, 議價狀態',
    '成交价格': '成交價格',
    '取消购买': '取消購買',
    '按还价金额购买': '按還價金額購買',
    '按原价购买': '按原價購買',
    '状态': '狀態',
    '确定要取消当前议价订单吗？': '確定要取消當前議價訂單嗎？',
    '订单取消成功': '訂單取消成功',
    '确定要按照卖家的还价金额': '確定要按照賣家的還價金額',
    '日元购买吗？': '日元購買嗎？',
    '提交成功，我们即将使用': '提交成功，我們即將使用',
    '日元与卖家沟通改价并购买': '日元與賣家溝通改價並購買',
    '确定要按照原价': '確定要按照原價',
    '日元购买吗': '日元購買嗎',
  },
  auctionCenter: {
    '竞价领先': '競價領先',
    '预约中': '預約中',
    '被超越': '被超越',
    '24小时内得标': '24小時內得標',
    '24小时内结束': '24小時內結束',
    '截标时间较早': '截標時間較早',
    '截标时间较晚': '截標時間較晚',
    '竞拍价格从高到低': '競拍價格從高到低',
    '竞拍价格从低到高': '競拍價格從低到高',
    '最小宽度': '最小寛度',
    '最大宽度': '最大寛度',
    '还没有任何竞拍信息': '還沒有任何競拍信息',
    '商品图片': '商品圖片',
    '商品ID': '商品ID',
    '当前状态': '當前狀態',
    '去雅虎竞拍下标': '去雅虎競拍下標',
    '取消置顶': '取消置頂',
    '数据加载中': '數據加載中',
    '输入数值进行排序，越大越靠前': '輸入數値進行排序，越大越靠前',
    '排序值': '排序値',
    '日元': '日元',
    '出价': '出價',
    '约': '約',
    '取消': '取消',
    '竞标日志': '競標日志',
    '未税': '未稅',
    '含税': '含稅',
    '输入关键词可过滤': '輸入關鍵詞可過濾',
    '确定要清空竞标日志吗?': '确定要清空競標日志嗎?',
    '最低出价': '最低出價',
    '出价金额': '出價金额',
    '含税金额': '含稅金額',
    '价格变动': '價格變動',
    '请输入出价金额': '請輸入出價金額',
    '本次最少加价': '本次最少加價',
    '竞拍中': '競拍中',
    '我的收藏': '我的收藏',
    '当客服非处于在线状态时，将无法为您处理备注事宜，这可能会导致商品在未得到最终确认前就被其他人购得。': '當客服非處於在綫狀态時，將無法為您處理備注事宜，這可能會導致商品在未得到最終确認前就被其他人購得。',
    '*请注意：填写备注则无法自动下单购买，需要人工确认后才能购买。': '*請注意：塡寫備注則無法自動下單購買，需要人工确認後才能購買。',
    '请输入价格': '請輸入價格',
    '修改': '修改',
    '元': '新台幣',
    '可用积分不足，请重试': '可用點數不足，請重試',
    '使用': '使用',
    '取消订单': '取消訂單',
    '支付': '支付',
    '￥': '$',
    '此费用为预估运费，实际运费以捆包后最终重量为准': '此費用為預估運費，實際運費以捆包後最終重量為準',
    '立即支付': '立即支付',
    '账单': '賬單',
    '通知': '通知',
    '购物车': '購物車',
    '收藏': '收藏',
    '自助代购': '自助代購',
    '竞拍中心': '競拍中心',
    '取消预约': '取消預約',
    '取消收藏成功': '取消收藏成功',
    '收藏成功': '收藏成功',
    '复制成功': '復制成功',
    '复制失败': '復制失敗',
    '在截止拍卖前5分钟时出价': '在截止拍賣前5分鍾時出價',
    '确定要取消预约吗？': '确定要取消預約嗎？',
    '商品ID、订单或商品标题': '商品ID、訂單或商品標題',
    '商品ID或商品标题': '商品ID或商品標題',
    '页': '頁',
    '天': '天',
    '时': '時',
    '分': '分',
    '秒': '秒',
    '备注成功': '備注成功',
    '默认': '默認',
    '截标时间较晚优先': '截標時間較晚優先',
    '截标时间较早优先': '截標時間較早優先',
    '竞拍价格较高优先': '競拍價格較高優先',
    '竞拍价格较低优先': '競拍價格較低優先',
    '显示全部价格': '顯示全部價格',
    '仅显示日元': '僅顯示日元',
    '仅显示人民币': '僅顯示新臺幣',
    '关闭页面': '關閉頁面',
    '商品信息不存在或已下架': '商品信息不存在或已下架',
    '确定要清空已结束的雅虎竞拍商品吗？': '确定要清空已結束的雅虎競拍商品嗎？',
    '该商品涉及不良信息已禁止访问': '該商品涉及不良信息已禁止訪問',
    '如您认为此商品没有涉及不良信息，请联系客服处理。': '如您認爲此商品沒有涉及不良信息，請聯繫客服處理。',
  }
};
